import mdAxios from 'core/common/config/axios-config';
import { observable } from 'mobx';
import { BrimMessage, ImportEntryBrimMessage } from './dataImportDomain';
import { GridParams } from 'core/grid/domain/grid';

class DataImportService{
    @observable public brimMessageObject: BrimMessage;

    // ////////// DataImport - BrimMessage  ////////////////////////////////////////////////////////////////////////////////

  validateBrimMessage(gridParams: GridParams) {
    return mdAxios.post('/brim-message/validate', gridParams)
    .then((response) => response.data);
  }

  acceptBrimMessage(gridParams: GridParams){
    return mdAxios.post('/brim-message/accept', gridParams)
    .then((response) => response.data);
  }
  
  rejectBrimMessgage(gridParams: GridParams){
    return mdAxios.post('/brim-message/reject', gridParams)
    .then((response) => response.data);
  }

  getBrimMessageDetail(brimMessageId: number,  initPrices: boolean): Promise<ImportEntryBrimMessage>{
    return mdAxios.get('/brim-message/' + brimMessageId, {params: {initPrices}})
    .then((response) => {
      console.log(response.data)
      return new ImportEntryBrimMessage(response.data)});
  }
}
const dataImportService = new DataImportService();
export default dataImportService;


// WEBPACK FOOTER //
// ./src/core/dataimport/dataImportService.ts